import React from 'react';
import PropTypes from 'prop-types';
// docs-page-shell
import ReactPageShell from '../../vendor/docs-page-shell/react-page-shell.js';
// dr-ui components
import AnalyticsShell from '@mapbox/dr-ui/analytics-shell';
import PageLayout from '@mapbox/dr-ui/page-layout';
import { buildMeta, findHasSection } from '@mapbox/dr-ui/page-layout/utils';
// site variables
import constants from '../constants';
// batfish modules
import { withLocation } from '@mapbox/batfish/modules/with-location';
// batfish dataSelectors
import navigation from '@mapbox/batfish/data/navigation';
import filters from '@mapbox/batfish/data/filters';
import mbxMeta from '@mapbox/batfish/data/mbx-meta';
// components
import AppropriateImage from './appropriate-image.js';

const {
  VERSION_IOS_MAPS_SDK,
  VERSION_IOS_NAV_SDK,
  VERSION_IOS_SEARCH_SDK,
  VERSION_VISION_SDK,
  LEGACY_IOS_MAPS_SDK_VERSION,
  LEGACY_IOS_NAV_SDK_VERSION
} = require('../constants.json');

const versions = {
  maps: VERSION_IOS_MAPS_SDK,
  navigation: VERSION_IOS_NAV_SDK,
  search: VERSION_IOS_SEARCH_SDK,
  vision: VERSION_VISION_SDK,
  'legacy/maps': LEGACY_IOS_MAPS_SDK_VERSION,
  'legacy/navigation': LEGACY_IOS_NAV_SDK_VERSION
};

// redirects old install headings to install page
function installRedirects(path) {
  const config = {
    '/ios/maps/guides/#install-the-maps-sdk': '/ios/maps/guides/install/',
    '/ios/navigation/guides/#install-the-navigation-sdk':
      '/ios/navigation/guides/install/',
    '/ios/search/guides/#install-the-search-sdk': '/ios/search/guides/install/'
  };
  return config[path] || undefined;
}

class PageShellWrapper extends React.PureComponent {
  componentDidMount() {
    const { hash, pathname } = this.props.location;
    const hasRedirect = installRedirects(`${pathname}${hash}`);
    if (hasRedirect) {
      window.location = hasRedirect;
    }
  }
  render() {
    const { location, children, frontMatter } = this.props;
    const meta = buildMeta(frontMatter, location.pathname, navigation);
    // get the section name to loop up version
    const { path } = findHasSection(navigation, location.pathname);
    return (
      <ReactPageShell
        site={constants.SITE}
        subsite={meta.subsite || undefined}
        {...this.props}
        meta={meta}
        darkHeaderText={true}
      >
        <AnalyticsShell
          mbxMetadata={mbxMeta[this.props.location.pathname]}
          location={location}
        >
          <PageLayout
            location={location}
            frontMatter={{
              ...frontMatter,
              ...(frontMatter.overviewHeader && {
                overviewHeader: {
                  ...frontMatter.overviewHeader,
                  image: frontMatter,
                  version: versions[path],
                  ...(frontMatter.overviewHeader.image && {
                    image: (
                      <AppropriateImage
                        imageId={frontMatter.overviewHeader.image}
                        alt=""
                        className="hmax300"
                      />
                    )
                  })
                }
              })
            }}
            constants={constants}
            navigation={navigation}
            filters={filters}
            AppropriateImage={AppropriateImage}
          >
            {children}
          </PageLayout>
        </AnalyticsShell>
      </ReactPageShell>
    );
  }
}

PageShellWrapper.propTypes = {
  meta: PropTypes.object,
  frontMatter: PropTypes.object.isRequired,
  children: PropTypes.node,
  location: PropTypes.object.isRequired
};

export default withLocation(PageShellWrapper);
